import styled from 'styled-components';
export const Wrapper = styled.div`
    margin: 8px;
    background: white;
    box-sizing: border-box;
    height: calc(100vh - 16px);
`;

export const TabWrapper = styled.div`
    margin-top: 24px;
    width: 100%;
    padding: 0 20px;

`;
